import { Outlet, createFileRoute } from "@tanstack/react-router";

import { CalendarProvider } from "@/hooks/use-calendar";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute("/events/$id/rules")({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "event_rules",
                to: APP_ROUTES_TO.EVENT_RULES,
            },
            title: "event_rules",
        },
    },
});

function RouteComponent() {
    return (
        <CalendarProvider>
            <Outlet />
        </CalendarProvider>
    );
}
